import { HttpContext, HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { UIService } from './ui.service';

export const SkipLoading = new HttpContextToken<boolean>(() => false);

/** Kontext požadavku bez globálního indikátoru načítání (našeptávače). */
export const SKIP_LOADING_CONTEXT = new HttpContext().set(SkipLoading, true);

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SkipLoading)) {
    return next(req);
  }

  const uiService = inject(UIService);
  uiService.startLoading();

  return next(req).pipe(
    finalize(() => {
      uiService.stopLoading();
    })
  );
};
